//普通对象转FormData格式
export const obj2formData = (param) => {
  let form_data = new FormData();
  for (let key in param) {
    form_data.append(
      key,
      param[key] === null || param[key] === undefined ? '' : param[key]
    );
  }
  return form_data;
};

//判断是否是空对象
export const isEmpty = (obj) => {
  if (obj === null || obj === undefined || obj === '') {
    return true;
  }
  return Object.keys(obj).length === 0;
};
